import React, { Fragment, Component } from 'react';
import Slider from './Slider';

class SliderGroup extends Component {
  handleInput = newItem => {
    const { onInput, setSubmitStatus, input, data } = this.props;
    const newInput = {
      ...input,
      ...newItem
    };
    if (Object.keys(newInput).length === data.questions.length) {
      setSubmitStatus(Object.keys(newInput).length === data.questions.length);
    }
    onInput(newInput);
  };

  render() {
    const { onInput, input } = this.props;

    /**
     * TODO:
     *  1. Add 'active' state to label: underline or highlight or something
     * */

    return (
      <Fragment>
        {this.props.data.questions.map(data_group => {
          return (
            <Slider
              key={data_group.question}
              data={data_group}
              onInput={onInput}
              input={input && input[data_group.question]}
              validationResult={this.props.validationResult}
              handleInput={this.handleInput}
            />
          );
        })}
      </Fragment>
    );
  }
}

export default SliderGroup;



// WEBPACK FOOTER //
// ../core/src/components/Slider/SliderGroup.js